import { httpGet, httpPatch } from '../services/http'
import authProvider from '../utils/authProvider'

const leadApi = process.env.REACT_APP_LEAD_INSPECTIONS_API

const LeadInspectionProvider = {
  getList: async (resource, { pagination, filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${leadApi}?f=${JSON.stringify(filter)}&p=${JSON.stringify(pagination)}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },

  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${leadApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },

  update: async (resource, { data, id }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPatch({ url: `${leadApi}/${id}`, config: { headers }, data: data })
    return Promise.resolve({ data: response })
  },
}

export default LeadInspectionProvider
